import React from "react";
import { Link } from "react-router";
import FullLayout from "@/layouts/FullLayout";
import { linkButtonClasses } from "@/helpers/style.helpers";
import { appLog } from "@/features/scanners/helpers";
import { fetchWorktables } from "./api";
import { WorktableInfo } from "./types";

export const WorktableList: React.FC = () => {
  const [worktables, setWorktables] = React.useState<WorktableInfo[]>([]);
  const [error, setError] = React.useState<string>("");

  React.useEffect(() => {
    fetchWorktables()
      .then(setWorktables)
      .catch((err: Error) => {
        setError("Werktafels konden niet geladen worden");
        void appLog(`[WORKTABLE] fetch worktables failed: ${err.message}`, true, "error", err);
      });
  }, []);

  return (
    <FullLayout header={<h2>Werktafels</h2>}>
      <div className="flex flex-col gap-4 justify-center">
        <div className="rounded bg-white px-4 py-3 text-center text-sm text-blue-900 shadow-sm">
          Kies jouw werktafel.
        </div>
        {worktables.map((worktable) => (
          <Link key={worktable.id} to={`/worktable/${worktable.id}`} className={`${linkButtonClasses} text-center`}>
            {worktable.name}
          </Link>
        ))}
        {!error && worktables.length === 0 && (
          <div className="text-center text-sm text-gray-700">Geen actieve werktafels gevonden.</div>
        )}
        {error && <div className="rounded bg-red-500 px-4 py-3 text-center text-white">{error}</div>}
      </div>
    </FullLayout>
  );
};

export default WorktableList;
